import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	DeleteCustomFieldDropdownOptionInput,
	DeleteCustomFieldDropdownOptionMutation,
	DeleteCustomFieldDropdownOptionMutation$rawResponse,
} from './__generated__/DeleteCustomFieldDropdownOptionMutation.graphql';
import type {Disposable} from 'relay-runtime';

const mutation = graphql`
	mutation DeleteCustomFieldDropdownOptionMutation($input: DeleteCustomFieldDropdownOptionInput!) @raw_response_type {
		deleteCustomFieldDropdownOption(input: $input) {
			clientMutationId
			deletedOptionId
			replacementOptionId
		}
	}
`;

function getOptimisticResponse(
	input: DeleteCustomFieldDropdownOptionInput
): DeleteCustomFieldDropdownOptionMutation$rawResponse {
	return {
		deleteCustomFieldDropdownOption: {
			clientMutationId: null,
			deletedOptionId: input.optionId,
			replacementOptionId: input.replacementOptionId ?? null,
		},
	};
}

function commit(
	environment: Environment,
	input: MutationInput<DeleteCustomFieldDropdownOptionInput>,
	onSuccess: RelayOnCompleted<DeleteCustomFieldDropdownOptionMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinitionDropdownOption - Deleted');

	return trackAndCommitMutation<DeleteCustomFieldDropdownOptionMutation>(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
		optimisticResponse: getOptimisticResponse(input),
	});
}

export default {commit};
